type Assets = {
  [key: string]: {
    apple: string;
    google: string;
  };
};

export const APP_STORE_RESOURCES: Assets = {
  default: {
    apple:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/appstore-en-a598f038a500451332fba37c0309efc599ac1254d7d4167840047e5fa7d4fe99.svg',
    google:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/googleplay-en-791346334d8111665ed456fc08ca7ff60bde40b302a9e4bfb140aeb4acd35045.svg',
  },
  en: {
    apple:
      'https://cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/appstore-en-a598f038a500451332fba37c0309efc599ac1254d7d4167840047e5fa7d4fe99.svg',
    google:
      'https://cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/googleplay-en-791346334d8111665ed456fc08ca7ff60bde40b302a9e4bfb140aeb4acd35045.svg',
  },
  ja: {
    apple:
      'https://cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/appstore-en-a598f038a500451332fba37c0309efc599ac1254d7d4167840047e5fa7d4fe99.svg',
    google:
      'https://cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/googleplay-en-791346334d8111665ed456fc08ca7ff60bde40b302a9e4bfb140aeb4acd35045.svg',
  },
  nl: {
    apple:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/appstore-nl-92c6ad6bf631b79d23b7364ff62ed3c85254e12077e5c27e3e97e66957336267.svg',
    google:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/googleplay-nl-f7d48b7232afecf527a45903dfd19970f7c09191f08b74bde7a0cec99f15f29b.svg',
  },
  de: {
    apple:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/appstore-du-c2ee442e35fb9792df351120b4c9af8724606b4d6db2dc10e575d672508e0b17.svg',
    google:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/googleplay-du-3efb8654e8b18745124bc7aa0cd64be754eaa6cfda8412820c12f99d7e0a423a.svg',
  },
  fr: {
    apple:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/appstore-fr-3125b4202ca61834efade74fa85da7b14d4ca756a8c5c1c99ab0be26facd0693.svg',
    google:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/googleplay-fr-ec063c58dc68e84747a63b53f834842711c870609122ab8dfe86814c0eb4756c.svg',
  },
  it: {
    apple:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/appstore-it-de79e40a9306b7d6a5f44879b4bbd50d532db8be618c8883ba115e35499d3fe6.svg',
    google:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/googleplay-it-391c408a6877815cc8205a269cf541fccd03d37cd6cee9832453213b7016e311.svg',
  },
  es: {
    apple:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/appstore-es-b250d1a2b1e2d746a889e711fb8018e4eac0d843a30cad84f6bd657345b35567.svg',
    google:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/googleplay-es-0a08bc9b47f2f017d0ed9a504dc0e63aa94d725703909df3a6eef63641b57557.svg',
  },
  'zh-Hans': {
    apple:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/appstore-zh_CN-54527b27a3a4c02541c1179e54844735ef1a396b92fdfaf7ca71d17909c33f8b.svg',
    google:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/googleplay-zh_CN-644b49a77306e8c2ea640403cd07b8bf9800c8b014d65e1c405020026c7991fe.svg',
  },
  'zh-Hant': {
    apple:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/appstore-zh_TW-f6b212738b8616adebf80263ce942f7d460d3794226c6e89cb5e29a91685a6ce.svg',
    google:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/googleplay-zh_TW-3c80173fcb205d88ad5d4510804c7c9b6ebae69871920526134b93003a4b4df1.svg',
  },
  pt: {
    apple:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/appstore-pt-c891d94319d09f9b90b40136b81f2328189923e28b1cf2b5d8c21307c4f6159f.svg',
    google:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/googleplay-pt-5dc82e7df1aa8604cb674088d328f355cbe743d81062209c17be237a5875a584.svg',
  },
  da: {
    apple:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/appstore-da-d2f9f4eb5b167d69afedb3dfcf0e60c4802b713ba6ddef8d805d897173378619.svg',
    google:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/googleplay-da-35f299087e2bb0ec9673804e6e6210e438426c108b7fd13d2b0c35eae129929a.svg',
  },
  sv: {
    apple:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/appstore-sv-73dd5166acbb16d27f9205b58c4f577d695dad2f9191302028dfb6270ad8943b.svg',
    google:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/googleplay-sv-222355a15aa3fbb2cf262f6705ea18ea5575543d9e57fcb57fb909f728a7c901.svg',
  },
  no: {
    apple:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/appstore-no-41d03960cfd6c691ae62c368d51aed1ca119c7950fd5986c1bcf47ae4e0c7ac7.svg',
    google:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/googleplay-no-89834776ceea89c86a2ef439cc7c2c762063be9ae021430b8d8c521561d8034a.svg',
  },
  pl: {
    apple:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/appstore-pl-07b238afa5002a56cdaedfce540483a0d101b82055b00b04e30706a92996d504.svg',
    google:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/googleplay-pl-ba3db29a69507283d1477e6fe28882a85016fc249dcd3684e49c7d7ef7b91a33.svg',
  },
  el: {
    apple:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/appstore-el-2c8780430ef2a7b36835bf956f4aa73adbc1665d37fdf6a84c62cf141824b7e0.svg',
    google:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/googleplay-el-cb8498418b9175c2a3932ddf4db19b6d185caa951f373cc2cb90848ba8ca3599.svg',
  },
  hu: {
    apple:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/appstore-hu-2ff82c6bf9fff0b7e5bce5d541bbe91a5c377c0397e4d269e4889dfc7ea09125.svg',
    google:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/googleplay-hu-0528fdfd79542df23c66f22a9e062f815713f17b0b580e55c423848e5e24357b.svg',
  },
  ro: {
    apple:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/appstore-ro-2e99be2fe8e6b02d8ebb6068f2b4e7a23d22861f6a11217f2baf6674bfd02010.svg',
    google:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/googleplay-ro-64b928f321341d738608212090f33ef205a908e03dbf4402758bc4d004696012.svg',
  },
  fi: {
    apple:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/appstore-fi-6f373d37baff965e61258cd09f6d4ccc33206760c63335bbb634b96ccbfa6f9d.svg',
    google:
      '//cdn.catawiki.net/assets/buyer/ui/v2/homepage/mobile/googleplay-fi-006ac57ea985d91480d6711c83002316d42f1d17da564a0848a0de1013016560.svg',
  },
};
